export default "__VITE_ASSET__03c4c03b__"